import { BCMSRecord, Workflow, useBCMSContext, useParams } from "@bcm-dev/bcms-vite";
import AddTransferTemplatePage from "components/pages/AddTransferTemplatePage";
import TransferTemplatesPage from "components/pages/TransferTemplatesPage";
import Classes, { TransferTemplate } from "model";
import React from "react";

// Steps of the workflow
const steps = [ TransferTemplatesPage, AddTransferTemplatePage ];

/**
 * @function AddTransferTemplateWorkflow
 * @param {Void} - No arguments are passed.
 * @returns {React.Component}
 * @exported true
 * @description The workflow component for adding an ach template.
 */
export default function AddTransferTemplateWorkflow(props) {
    const controller = useBCMSContext();
    const { stepID } = useParams();
    // Get the inital state of the workflow
    const value = getDefault(controller);
    // Return the workflow component
    return <Workflow value={ value } steps={ steps } step={ stepID } />;
}
// Return the steps of the workflow
export const getWorkflowSteps = () => steps;

/**
 * @function getDefault
 * @param {Controller} controller - A global controller.
 * @returns {Object}
 * @exported true
 * @description Function to get the default state of the workflow
 */
export const getDefault = controller => {
    BCMSRecord.globalControllerFor(Classes, controller);

    // Return the default workflow state
    return { 
        data: {
            templates: TransferTemplate.initAll().filter(item => item.id !== undefined),
            templateAdded: false
        },
        ui: {
            // No shared ui for now.
        }
    };
};